import React from 'react'
import { bool, number, string } from 'prop-types'

export function TiltifyCircle({
  ariaHidden,
  stroke,
  fill,
  focusable,
  height,
  title,
  width,
  ...rest
}) {
  const h = height || '1rem'
  const w = width || '1rem'

  return (
    <svg
      viewBox='0 0 300 300'
      width={w}
      height={h}
      aria-hidden={ariaHidden}
      focusable={focusable}
      fill={fill}
      stroke={stroke}
      {...rest}
    >
      {title ? <title>{title}</title> : null}
      <path
        stroke='none'
        d='M171.5,128.206343 L172.618757,128.379286 L205.513507,133.51989 C216.100443,134.724662 223.961163,132.732771 229.086137,127.508644 C231.189318,124.96246 232.525248,121.97369 233.119994,118.497221 L233.319809,116.537298 C233.338296,116.036684 233.392384,115.526532 233.410872,115.025918 C233.028529,105.482067 226.298379,98.5922977 213.220423,94.3566094 L106.374055,62.2863821 C103.830676,61.4808995 101.128357,60.7942599 98.260095,60.3427231 C98.0986289,60.3097325 97.9465994,60.3119598 97.8208292,60.2697857 C90.1753188,59.0771612 83.2567497,60.7403479 77.0394206,65.3039788 C70.8218309,69.8680608 67.1058524,75.9347338 65.9099321,83.5756915 C64.7045752,91.1814314 66.3923009,98.0497185 70.9566677,104.261595 C72.05501,105.797423 73.2932273,107.143261 74.6191826,108.389334 C76.9551657,110.69924 80.3140333,112.696937 84.6051646,114.330451 C85.9801535,114.762705 87.3716793,115.114272 88.8058103,115.340041 C89.002877,115.363492 89.1287426,115.406022 89.2450762,115.412978 L121.580409,120.480212 C121.527145,121.146452 121.5,121.820056 121.5,122.5 L121.5,226.5 C121.5,240.307119 132.692881,251.5 146.5,251.5 C160.307119,251.5 171.5,240.307119 171.5,226.5 L171.5,128.206343 Z M104.81808,0 L195.18192,0 C228.579084,0 243.17837,2.81925209 258.301082,10.9069672 C271.578291,18.0076964 281.992304,28.4217086 289.093033,41.6989178 C297.180748,56.8216302 300,71.4209157 300,104.81808 L300,195.18192 C300,228.579084 297.180748,243.17837 289.093033,258.301082 C281.992304,271.578291 271.578291,281.992304 258.301082,289.093033 C243.17837,297.180748 228.579084,300 195.18192,300 L104.81808,300 C71.4209157,300 56.8216302,297.180748 41.6989178,289.093033 C28.4217086,281.992304 18.0076964,271.578291 10.9069672,258.301082 C2.81925209,243.17837 0,228.579084 0,195.18192 L0,104.81808 C0,71.4209157 2.81925209,56.8216302 10.9069672,41.6989178 C18.0076964,28.4217086 28.4217086,18.0076964 41.6989178,10.9069672 C56.8216302,2.81925209 71.4209157,0 104.81808,0 Z M238,68.0005583 C238,63.0094079 236.247788,58.788169 232.743363,55.2571955 C229.212389,51.7525052 224.964602,49.9737442 220,50.0002928 C215.035398,49.9737442 210.787611,51.7525052 207.283186,55.2571955 C203.752212,58.788169 202,63.0094079 202,68.0005583 C202,72.9651601 203.752212,77.2129477 207.283186,80.7173725 C210.787611,84.2483459 215.035398,86.0005583 220,86.0005583 C224.964602,86.0005583 229.212389,84.2483459 232.743363,80.7173725 C236.247788,77.2129477 238,72.9651601 238,68.0005583 Z'
      />
    </svg>
  )
}

TiltifyCircle.defaultProps = {
  ariaHidden: false,
  focusable: false,
  stroke: '#000',
  fill: '#000',
}

TiltifyCircle.propTypes = {
  ariaHidden: bool,
  stroke: string,
  fill: string,
  focusable: bool,
  height: number,
  title: string,
  width: number,
}
